// Single source of truth for Joylo's public social profiles.
// Consumed by the footer (links) and seo-config.ts (Organization sameAs).
// Keep this file Node-safe: no browser APIs, no React imports — prerender.tsx pulls it in at build time.

export interface SocialProfile {
  name: string;
  handle: string;
  url: string;
}

export const socialProfiles: SocialProfile[] = [
  { name: 'Instagram', handle: '@joylo.ai', url: 'https://www.instagram.com/joylo.ai' },
  { name: 'TikTok', handle: '@joylo.ai', url: 'https://www.tiktok.com/@joylo.ai' },
  { name: 'YouTube', handle: '@JoyloAI', url: 'https://www.youtube.com/@JoyloAI' },
  { name: 'X', handle: '@Joylo_ai', url: 'https://x.com/Joylo_ai' },
  { name: 'LinkedIn', handle: 'Joylo AI', url: 'https://www.linkedin.com/company/joylo-ai/' },
  { name: 'Medium', handle: 'joyloai', url: 'https://medium.com/joyloai' },
  { name: 'DEV Community', handle: 'joylo', url: 'https://dev.to/joylo' },
];

// The X handle doubles as the twitter:site meta value.
export const twitterHandle = '@Joylo_ai';

export const socialUrls = socialProfiles.map((profile) => profile.url);
